import React from 'react';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
import pxlogo from '../icons/500px-logo.png';



export const Footer = (props) => {
    let d = new Date();
    let n = d.getFullYear();
    return (
        <div id="footer">
            <div id="social">
                <div className="sociallinks">
                    <a href="https://www.facebook.com/himanshu27.stu" rel="noopener noreferrer" target="_blank"><FacebookIcon color="secondary" fontSize="large" /></a>
                </div>
                <div className="sociallinks">
                    <a href="https://www.twitter.com/imhimanshu27" rel="noopener noreferrer" target="_blank"><TwitterIcon color="secondary" fontSize="large" /></a>
                </div>
                <div className="sociallinks">
                    <a href="https://www.500px.com/p/himanshu27stu?view=photos" rel="noopener noreferrer" target="_blank"><img style={{"backgroundColor": "#c5c5c5", "borderRadius": "5px"}} src={pxlogo} width="34px" height="34px" alt="500pxLogo" /></a>
                </div>
                <div className="sociallinks">
                    <a href="https://www.linkedin.com/in/im-himanshu27" rel="noopener noreferrer" target="_blank"><LinkedInIcon color="secondary" fontSize="large" /></a>
                </div>
                <div className="sociallinks">
                    <a href="https://www.instagram.com/himanshu.tasveer" rel="noopener noreferrer" target="_blank"><InstagramIcon color="secondary" fontSize="large" /></a>
                </div>
            </div>
            <div id="footerText">
                This site is designed by Himanshu Mahawar.
            </div>
            <br />
            <div id="footerCopy">
                <p>Copyright © 2020 {(n > 2020) ? "-" + n : ""} <a id="tasveerlink" href="http://himanshu.surge.sh">tasveer</a>. All rights reserved.</p>
            </div>
        </div>
    );
}